/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventCreated_job$ref: FragmentReference;
export type JobEventCreated_job = {|
  +uuid: string,
  +createdAt: ?any,
  +agentQueryRules: ?$ReadOnlyArray<string>,
  +cluster: ?{|
    +name: string,
    +uuid: string,
    +organization: ?{|
      +slug: string
    |},
  |},
  +clusterQueue: ?{|
    +key: string,
    +uuid: string,
    +cluster: ?{|
      +name: string,
      +uuid: string,
      +organization: ?{|
        +slug: string
      |},
    |},
  |},
  +concurrency: ?{|
    +group: string,
    +limit: number,
  |},
  +step: ?{|
    +uuid: string,
    +key: ?string,
    +conditional: ?string,
    +dependencies: ?{|
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +uuid: string,
          +key: ?string,
        |}
      |}>
    |},
  |},
  +$refType: JobEventCreated_job$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "cluster",
  "storageKey": null,
  "args": null,
  "concreteType": "Cluster",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    v0,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "organization",
      "storageKey": null,
      "args": null,
      "concreteType": "Organization",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "slug",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "key",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobEventCreated_job",
  "type": "JobTypeCommand",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "createdAt",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "agentQueryRules",
      "args": null,
      "storageKey": null
    },
    v1,
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "clusterQueue",
      "storageKey": null,
      "args": null,
      "concreteType": "ClusterQueue",
      "plural": false,
      "selections": [
        v2,
        v0,
        v1
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "concurrency",
      "storageKey": null,
      "args": null,
      "concreteType": "JobConcurrency",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "group",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "limit",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "step",
      "storageKey": null,
      "args": null,
      "concreteType": "StepCommand",
      "plural": false,
      "selections": [
        v0,
        v2,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "conditional",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "dependencies",
          "storageKey": "dependencies(first:10)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 10,
              "type": "Int"
            }
          ],
          "concreteType": "DependencyConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "DependencyEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Dependency",
                  "plural": false,
                  "selections": [
                    v0,
                    v2
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '164733305a70d0de007676e18e19f4ab';
module.exports = node;
